import { Chip, MenuItem, Stack, Tooltip } from '@mui/material';
import WushPopover from '../../layout/WushPopover';
import useOrderStore from '../../../stores/useOrderStore';
import update from '../../../api/auth/orders/update';
import DeleteConfirmation from '../../form/DeleteConfirmation';

const BACKGROUND_COLORS = {
  draft: 'lightgrey',
  review: 'grey',
  confirmed: '#00800160',
  paid: 'green',
  cancelled: 'red',
};

const FONT_COLORS = {
  draft: 'black',
  review: 'black',
  confirmed: 'white',
  paid: 'white',
  cancelled: 'white',
};

const STATUSES = [
  {
    label: "Draft",
    value: "draft",
  },
  {
    label: "Review",
    value: "review",
  },
  {
    label: "Confirmed",
    value: "confirmed",
  },
  {
    label: "Paid",
    value: "paid",
  },
  {
    label: "Cancelled",
    value: "cancelled",
  }
];

export default function OrderStatusChip({ order }) {
  const { updateOrder } = useOrderStore();

  const toolTipText = () => {
    if(order.is_backend) {
      return "";
    } else if(order.checkout_status === 'initial') {
      return `Customer has not started checkout process`;
    } else if(order.checkout_status === 'customer_information') {
      return `Customer has clicked the checkout button but has not entered any personal information`;
    } else if(order.checkout_status === 'delivery_information') {
      return `Customer has entered their personal information`;
    } else if(order.checkout_status === 'summary') {
      return `Customer has entered their delivery information`;
    }
  };

  const handleUpdateOrder = (status) => {
    update(order.id, { status }, (response) => {
      updateOrder(response);
    });
  };

  return (
    <Tooltip title={toolTipText()}>
      <WushPopover
        forceClose={true}
        anchor={
          <Chip
            label={order.status.toUpperCase()}
            size='small'
            style={{
              backgroundColor: BACKGROUND_COLORS[order.status],
              color: FONT_COLORS[order.status],
              fontSize: '10px',
              fontWeight: 'bold',
              cursor: 'pointer',
            }}
          />
        }
      >
        <Stack p={1}>
          {STATUSES.map((status) => (
            <DeleteConfirmation
              key={status.value}
              handleDelete={() => handleUpdateOrder(status.value)}
              title="Are you sure you want to update the order status?"
              ctaText="Update"
              ctaColor="primary"
            >
              <Stack sx={{ cursor: 'pointer' }}>
                <MenuItem
                  sx={{
                    bgcolor: status.value === order.status && BACKGROUND_COLORS[order.status],
                    color: status.value === order.status && FONT_COLORS[order.status],
                  }}
                >
                  {status.label}
                </MenuItem>
              </Stack>
            </DeleteConfirmation>
          ))}
        </Stack>
      </WushPopover>

    </Tooltip>
  );
}